import { type RouteRecordRaw } from 'vue-router'

export default [
  // Redis
  {
    path: '/redis',
    component: () => import('../modules/redis/layout.vue'),
    meta: {
      title: 'Redis',
      showTabs: true,
      tabs: [
        { path: '/redis', name: '概览', key: 'overview' },
        { path: '/redis/instance', name: '实例', key: 'instance' }
      ]
    },
    children: [
      // Redis 概览
      {
        path: '',
        name: 'RedisOverview',
        component: () => import('../modules/redis/overview/index.vue')
        // meta: { activeTab: 'overview' }
      },
      // Redis 实例
      {
        path: 'instance',
        name: 'RedisInstance',
        component: () => import('../modules/redis/instance/index.vue')
        // meta: { activeTab: 'instance' }
      },
      // Redis 未恢复告警
      {
        path: 'alert',
        name: 'RedisAlerts',
        component: () => import('../modules/redis/alerts/index.vue')
        // meta: { activeTab: 'alerts' }
      }
    ]
  },
  // Redis 实例详情（独立页面，不显示概览/实例tab）
  {
    path: '/redis/instance/:uid',
    name: 'RedisInstanceDetail',
    component: () => import('../modules/redis/instance/detail/index.vue'),
    meta: {
      title: 'Redis 实例详情',
      showTabs: false
    }
  }
] satisfies RouteRecordRaw[]
